import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IFormBuilder, IFormGroup } from '@rxweb/types';
import { AuthService } from '../services/auth.service';

interface ResetPasswordForm {
  email: string | null;
}
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent implements OnInit {
  formBuilder: IFormBuilder;
  resetPasswordForm: IFormGroup<ResetPasswordForm>;
  constructor(formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router) {
this.formBuilder = formBuilder;
}

ngOnInit() {
  this.resetPasswordForm = this.formBuilder.group<ResetPasswordForm>({
    email: this.formBuilder.control(null, [Validators.required, Validators.email]),
  });

}
async resetPassword() {
  if (this.resetPasswordForm.valid) {
    const { email } = this.resetPasswordForm.value;
    await this.authService.ForgotPassword(email);
    const onderneming = "/" + JSON.parse(localStorage.getItem('onderneming')) + "/tools";
    await this.router.navigateByUrl(onderneming);
  }
}
}
